<template>
  <div class="grid grid-cols-3 rounded-sm bg-white">
    <button @click="emit('minus')" class="btn p-0" :disabled="props.loading">
      <IconRevert></IconRevert>
    </button>
    <div class="flex h-full w-full items-center justify-center font-semibold">
      {{ props.count }}
    </div>
    <button @click="emit('plus')" class="btn" :disabled="props.loading">+</button>
  </div>
</template>
<script lang="ts" setup>
import IconRevert from '@/components/icons/IconRevert.vue'

const props = defineProps<{
  count: number
  loading: boolean
}>()
const emit = defineEmits<{
  (e: 'minus'): void
  (e: 'plus'): void
}>()
</script>
